import { BoxProps, Grid2, SxProps } from '@mui/material'
import { FC } from 'react'
import { Outlet } from 'react-router'
import { Header } from '../Header'
import { Sidebar } from '../Sidebar'


interface MainProps extends BoxProps {
  sx?: SxProps
}

export const MainLayout: FC<MainProps> = () => {


  return (
    <Grid2 container direction="column" spacing={0} height="100%" wrap="nowrap" sx={{maxHeight:'100%', overflow:'hidden'}}>
      <Header />
      <Grid2
        container
        height="100%"
        flexGrow={1}
        sx={{ position: 'relative', maxHeight:"100%", overflow:'hidden' }}
        wrap="wrap"
        direction="row"

      >
        <Sidebar />
        <Outlet />
      </Grid2>
    </Grid2>
  )
}
